import React from "react";
import logo from "./../../assets/Dtac.png";
import userImg from "./../../assets/user.png";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from "@material-ui/core/Fab";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Zoom from "@material-ui/core/Zoom";
import PersonIcon from "@material-ui/icons/Person";
import { useHistory } from "react-router-dom";
//Function
import { Logout } from "../../utils/sessions";
import * as alertDialog from "../../utils/alert";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import manualImg from '../../assets/manual.png';
import faqImg from '../../assets/faq.png';
import Link from '@material-ui/core/Link';
import { Divider } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  appbar: {
    backgroundColor: "#FFF",
    color: "black"
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
    //justifyContent: "center",
    //alignSelf: "center",
  },
  grow: {
    flexGrow: 1,
  },
  logo: {},
  name: {},
  icon: {
    marginLeft: theme.spacing(1),
    //marginBottom:theme.spacing(1)
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export const MuiHeader = ({ children, user, ...props }) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <React.Fragment>
      <header>
        <AppBar className={classes.appbar}>
          <Toolbar className={classes.toolbar}>
            <Link
              component="button"
              variant="body2"
              onClick={() => history.push("/")}
            >
              <img src={logo} height="50px" width="305px" alt="" title="Home"  />

            </Link>
            {/* <h5 style={{ margin: 'auto', fontWeight: 'bold' }}>BI Web Portal</h5> */}
            <div className={classes.grow} />

            <Typography style={{ margin: 'auto', fontWeight: 'bold' }}>
              {user}
            </Typography>
            {/* <PersonIcon className={classes.icon} onClick={async () => {
              let res = await alertDialog.ConfirmCommon("Do you want to Logout ?", "Yes", "No")
              if (!res) return;
              Logout();
            }} /> */}
            <Link
              component="button"
              variant="body2"
              onClick={async () => {
                let res = await alertDialog.ConfirmCommon("Do you want to Logout ?", "Yes", "No")
                if (!res) return;
                Logout();
              }} >

              <img src={userImg} style={{ marginLeft: '15px', marginRight: '5px' }} alt="Log out" title="Log out" width="35" height="35" />

            </Link>
            <Divider className={classes.divider} orientation="vertical" />
            <Link
              component="button"
              variant="body2"
              onClick={() => history.push("/Faq")}
            >
              <img src={faqImg} style={{ marginLeft: '1px' }} alt="FAQ" title="FAQ" width="40" height="40" />

            </Link>
            <Divider className={classes.divider} orientation="vertical" />
            <Link
              component="button"
              variant="body2"
              onClick={() => history.push("/Manual")}
            >

              <img src={manualImg} style={{ marginLeft: '1px' }} alt="Manual" width="40" height="40" title="Manual" />

            </Link>

            <Divider className={classes.divider} orientation="vertical" />

            {/* <HelpOutlineIcon
                className={classes.icon}
                onClick={() =>   window.open("/Manual", '_blank')}
              /> */}
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
      </header>
      {children}
      <section name="goTop">
        <ScrollTop {...props}>
          <Fab color="secondary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </section>
    </React.Fragment>
  );
};
MuiHeader.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  user: PropTypes.string

};
export default MuiHeader;
